import { REOPEN_COMMENT } from 'src/redux/pull-request/actions';
import { BucketDispatch } from 'src/types/state';
import authRequest, { jsonHeaders } from 'src/utils/fetch';

import { ConversationResolution } from '../components/types';

/**
 * Resolves a comment based on the Id, Returns the resolution details.
 */
export async function reopenComment(
  dispatch: BucketDispatch,
  commentId: number,
  conversationResolution: ConversationResolution
) {
  // eslint-disable-next-line babel/no-invalid-this
  const { config } = this;
  const { urls } = config;

  dispatch({
    type: REOPEN_COMMENT.REQUEST,
    payload: { id: commentId },
  });

  const response = await fetch(
    authRequest(urls.commentResolve(commentId), {
      method: 'DELETE',
      headers: jsonHeaders,
    })
  );

  if (!response.ok) {
    throw Error(response.statusText);
  }

  dispatch({
    type: REOPEN_COMMENT.SUCCESS,
    payload: { id: commentId },
  });
  conversationResolution(null);
}
